import { Reducer, AnyAction } from 'redux';
import { ISagaModule } from 'redux-dynamic-modules-saga';
import { templatesReducer } from './reducer.Templates';

const moduleName = 'templates';

const reducerMap = { [moduleName]: templatesReducer };

type TemplatesModule = {[key in keyof typeof reducerMap ]: ReturnType<typeof reducerMap[key]> };

export function getTemplatesModule(): ISagaModule<TemplatesModule>  {
    return {
        id: moduleName,
        reducerMap: reducerMap as {[s in keyof TemplatesModule]: Reducer<TemplatesModule[s], AnyAction>},
        sagas: [

        ],
    };
}